import { FC, useState } from 'react'

import { useNavigate, NavigateFunction } from 'react-router-dom'

import { useTranslation } from 'react-i18n-lite'

import { ErrorMessage } from 'infrastructure/shared/types'

import { postWorkflow } from 'workflow/shared/api'
import { PostWorkflowResponse } from 'workflow/shared/types'

import { useWorkflowmodels } from 'workflowmodel/List/hooks'

const List: FC = (): JSX.Element => {
  const { t } = useTranslation()

  const workflowmodels = useWorkflowmodels()

  const navigate: NavigateFunction = useNavigate()

  // Estado para o texto do filtro
  const [filterText, setFilterText] = useState('')

  const handleOnClick = (workflowmodelUuid: string) => {
    postWorkflow({ workflowmodel_uuid: workflowmodelUuid })
      .then((response: PostWorkflowResponse) =>
        navigate(`/workflow/${response.data.workflow.uuid}`)
      )
      .catch((error: ErrorMessage) => {
        console.error('Error:', error.message)
      })
  }

  // Filtrar os elementos com base no texto digitado
  const filteredWorkflowmodels = workflowmodels.filter(({ des }) =>
    des.toLowerCase().includes(filterText.toLowerCase())
  )

  return (
    <div style={{ padding: '20px' }}>
      <h2
        style={{ textAlign: 'center', marginBottom: '10px', color: '#007BFF' }}
      >
        {t('workflowmodel.available-workflows')}
      </h2>
      <div style={{ marginBottom: '20px' }}>
        <input
          type='text'
          placeholder={t('workflowmodel.filter-workflowmodels')}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          autoFocus
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            textTransform: 'uppercase',
            marginBottom: '20px'
          }}
        />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px'
        }}
      >
        {filteredWorkflowmodels.length > 0 ? (
          filteredWorkflowmodels.map(({ uuid: workflowmodelUuid, des }) => (
            <div
              key={workflowmodelUuid}
              onClick={() => handleOnClick(workflowmodelUuid)}
              style={{
                backgroundColor: '#007BFF',
                borderRadius: '12px',
                padding: '15px',
                color: '#FFFFFF',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s ease',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '150px'
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'scale(1.05)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'scale(1)')
              }
            >
              <small
                style={{
                  fontSize: '12px',
                  color: '#FFFFFF',
                  opacity: 0.7,
                  textAlign: 'right',
                  marginBottom: '10px'
                }}
              >
                {t('workflowmodel.instantiate')}
              </small>
              <h3
                style={{
                  margin: '0',
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  wordBreak: 'break-word'
                }}
              >
                {des}
              </h3>
            </div>
          ))
        ) : (
          <p style={{ textAlign: 'center' }}>
            {t('workflowmodel.no-results-found')}
          </p>
        )}
      </div>
    </div>
  )
}

export default List
